import { createFileRoute } from '@tanstack/react-router';
import RouteEdit from '~/containers/RouteEdit';

export const Route = createFileRoute('/trolley-routes/$routeId')({
  component: RouteEdit,
});
